import { Container } from '@mui/material';
import { NavLink, useParams } from "react-router-dom";
import { useEffect, useState } from 'react';

import { ITransporter } from "../../../types/transporter";

import { useUserContext } from "../../../contexts/userContext";

import { TransporterService } from "../../../services/transporterService";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import DocumentTable from '../../tables/documentTable';
import DocumentViewer from '../../documentViewer';
import Spinner from '../../spinner';
import TransporterDetailsForm from '../../forms/transporterDetailsForm';
import TransporterAddressesForm from '../../forms/transporterAddressesForm';
import TransporterContactForm from '../../forms/transporterContactForm';
import TransporterVendorForm from '../../forms/transporterVendorForm';
import { Icons } from '../../icons';
import { useListContext } from '../../../contexts/listContext';

const TransporterEdit = () => {
	const userContext = useUserContext();
	const listContext = useListContext();
	let { id } = useParams();
	const [transporter, setTransporter] = useState<ITransporter>();
	const [activeTab, setActiveTab] = useState("details");
	const [isLoadingTransporter, setIsLoadingTransporter] = useState(true);
	const [isInitialLoad, setIsInitialLoad] = useState(true);
	const [selectedDocumentId, setSelectedDocumentId] = useState<string>();
	const [entityTypeId, setEntityTypeId] = useState("");

	useEffect(() => {
		let et = listContext.entityTypes.filter((item) => { return item.name.toLowerCase() == "transporter" })
	  
		if(et.length > 0){
		  setEntityTypeId(et[0].value);
		}
  
	  }, [id])

	const getTransporter = async () => {
		if (id) {
			TransporterService.getTransporter(id)
				.then((response) => {
					console.log('TransporterService.getTransporter: SUCCESS', response);
					setTransporter(TransporterService.mapTransporter(response.data));
				})
				.catch((error) => {
					console.log('TransporterService.getTransporter: ERROR', error)
				})
				.finally(() => {
					setIsLoadingTransporter(false);
					setIsInitialLoad(false);
				});
		}
	}

	const handleDocumentDeleted = (id: number) => {
		transporter.documents = transporter.documents.filter(doc => doc.id !== id);
		setTransporter({...transporter});
	}

	useEffect(() => {
		getTransporter();
	}, [id])

	return (
		<div className="hwi-transporter-edit">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext.permissions?.canManageTransporters}>
				<Spinner dependency={isLoadingTransporter && isInitialLoad} text='Loading transporter...'>
						<section className="management-page-header">
							<div className="title">
								<NavLink to="/transporter">
									<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
								</NavLink>
								{transporter?.details?.name}
							</div>
							<div className="tabs">
								<div className={activeTab == "details" ? "tab active" : "tab"} onClick={() => setActiveTab("details")}>Details</div>
								<div className={activeTab == "addresses" ? "tab active" : "tab"} onClick={() => setActiveTab("addresses")}>Addresses</div>
								<div className={activeTab == "contact" ? "tab active" : "tab"} onClick={() => setActiveTab("contact")}>Contact</div>
								<div className={activeTab == "vendors" ? "tab active" : "tab"} onClick={() => setActiveTab("vendors")}>Vendors</div>
								<div className={activeTab == "documents" ? "tab active" : "tab"} onClick={() => setActiveTab("documents")}>Documents</div>
							</div>
						</section>
						<Spinner dependency={isLoadingTransporter} text='Loading transporter...'>
							{activeTab == "details" && transporter?.details && id ? (
								<TransporterDetailsForm action="edit" id={id} details={transporter.details} reloadData={getTransporter}></TransporterDetailsForm>
							) : (<></>)
							}
							{activeTab == "addresses" && transporter?.mailingAddress && transporter?.physicalAddress && id ? (
								<TransporterAddressesForm id={id} shippingAddress={transporter.physicalAddress} mailingAddress={transporter.mailingAddress} reloadData={getTransporter}></TransporterAddressesForm>
							) : (<></>)
							}
							{activeTab == "contact" && transporter?.contact && id ? (
								<TransporterContactForm id={id} contact={transporter.contact}></TransporterContactForm>
							) : (<></>)
							}
							{activeTab == "vendors" && transporter?.contact && id ? (
								<TransporterVendorForm id={id!} vendors={transporter.vendors}></TransporterVendorForm>
							) : (<></>)
							}
							{activeTab == "documents" && transporter?.documents ? (
								<div className="hwi-document-list">
									<DocumentTable 
										data={transporter?.documents} 
										entityId={id} 
										entityTypeId={entityTypeId} 
										hideAddDocumentsLink={false} 
										hideDeleteDocumentsLink={false} 
										onRequestListRefresh={getTransporter}
										onViewDocument={(id) => { setSelectedDocumentId(id?.toString()) }} 
										onDocumentDeleted={(id) => {handleDocumentDeleted(id)}}										
									></DocumentTable>
									{selectedDocumentId &&
										<DocumentViewer documentId={+selectedDocumentId}></DocumentViewer>
									}
								</div>
							) : (<></>)
							}
						</Spinner>
					</Spinner>
					{/* <Json data={transporter}></Json> */}
				</PermissionGate>
			</Container>
		</div>
	);
};

export default TransporterEdit;